import React, { useState, useEffect } from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
  withResolver, PendingButton,
} from "components/common";
import {
  FormGroup,
  SaveButton,
  BackButton,
  DatePicker,
  required,
} from "components/common/Forms";
import { compose, withState, withStateHandlers } from "recompose";
import { LocalForm, Control } from "react-redux-form";
import { isUndefined, orderBy } from "lodash";
import { isEmail } from "validator";
import { Trans, useTranslation } from "react-i18next";
import moment from "moment";
import { actions } from "react-redux-form";
import { Row, Col, Button } from "reactstrap";
import useModal from "../../hooks/useModal";
import { NotificationManager } from "react-notifications";
import withReload from "../../components/common/withReload";
import {useMutation} from "react-query";
import {useClient} from "../../hooks";
import Select from "react-select";
import { ColouredLink } from "components/HoverCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LoadingMsg from "components/common/LoadingMsg";
import GetBack from "components/refactoring/BackButton";
import { getOutlineStyle } from "services/util";

const passwordsMatch = ({ password, confirmPassword }) =>
  password === confirmPassword;

const ImpersonateButton = ({ email, ...props }) => {
  const client = useClient();
  const { mutateAsync, isLoading } = useMutation(() => client.get(`admin/impersonate`, {
    params: {
      email
    }
  }), {
    onSuccess: () => {
      window.location.href = "/";
    },
    useErrorBoundary: false
  });

  return (
    <PendingButton onClick={mutateAsync} pending={isLoading} translate={false} {...props}>
      <Trans>Impersonate</Trans>
    </PendingButton>
  )
}

export const UserEdit = ({
  mode,
  item,
  form,
  onBack,
  setDispatch,
  onSubmit,
  onUpdate,
  onChange,
  renderServerError,
  readOnly,
  stats,
  client,
  dispatch,
  reload,
  match,
}) => {

  const history = useHistory()

  const { Modal, setIsOpen, isOpen, ModalHeader, ModalBody, ModalFooter } =
    useModal();
  const { t } = useTranslation();
  async function onActivate() {
    try {
      await dispatch(actions.submit("local"));
      dispatch(actions.setPending("local", true));
      await client.post(`users/${item.id}/activate`).get("data");
      NotificationManager.success(t("User membership activated"));
      setIsOpen(false);
      reload();
    } finally {
      dispatch(actions.setPending("local", false));
    }
  }

  const [plans, setPlans] = useState()
  const [loading, setLoading] = useState(true)
  const [isSetPass, setPassword] = useState(false)
  
  const fetchData = async () => {
    try { 
      client.get('subscription-plans').then(resp => {
        setPlans(resp.data)
      })
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
    }
  };

useEffect(() => {

  fetchData();
}, []);

const linkClick = () => {
  history.push("/subscription/plan/new")
}

const options = [
  { value: "MONTHLY", label: "Monthly" },
  { value: "ANNUAL", label: "Annually" },
];

const colStyle = {
  xs: false,
  md: 12,
  className: "pt-1 pb-1"
}

const isNew = match.params.id === "new"
const isSubscriber = item?.role === "Subscriber"

const planOptions = plans?.length > 0 ? plans?.map(item => ({ label: t(item.name), value: item.id })) : undefined

  return (
    <Page title={`${mode} ${isSubscriber ? "Subscriber" : "User"}`}>
      <div className="d-flex justify-content-between align-items-center">
        <GetBack styleClass="my-2"/>
        {(item.id && item.is_active) && <ImpersonateButton email={item.email} className="float-right"/>}
        {(!item.is_active || item.suspended) &&
          <div>
            {!item.is_active && <span style={getOutlineStyle('#E64848')}><Trans>Not Active</Trans></span>}
            {item.suspended && <span className="ml-1" style={getOutlineStyle('#E64848')}><Trans>Suspended</Trans></span>}
          </div>
        }
      </div>
      {loading ? <LoadingMsg/> :
      <div>
      {plans && !planOptions ? <div className="text-center" style={{fontSize: "1.2em"}}><p><Trans>Please Create a <ColouredLink onClick={() => linkClick()}>Subscription Plan</ColouredLink> To Create A User</Trans></p></div> :
      <LocalForm
        initialState={item}
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        onUpdate={onUpdate}
        onChange={onChange}
        validators={{
          "": { passwordsMatch },
          email: { isEmail },
          company_name: { required },
          last_name: { required },
        }}
      >
        {isOpen ? (
          <Modal>
            <ModalHeader>
              <Trans>Activate membership</Trans>
            </ModalHeader>
            <ModalBody>
              <Trans>
                Are you sure you want to activate this membership? This will end
                the trial and generate an invoice for this user.
              </Trans>
            </ModalBody>
            <ModalFooter>
              <Row form>
                <Col xs="auto">
                  <Button color="link" onClick={() => setIsOpen(false)}>
                    Close
                  </Button>
                </Col>
                <Col xs="auto">
                  <SaveButton form={form} onClick={onActivate}>
                    Confirm
                  </SaveButton>
                </Col>
              </Row>
            </ModalFooter>
          </Modal>
        ) : null}
        <Row>
          {!isNew && 
            <Col {...colStyle}>
              <FormGroup label="User ID" model=".id">
                <Control.text placeholder={item?.id} model=".ids" disabled/>
              </FormGroup>
            </Col>
          }
          <Col {...colStyle}>
            <FormGroup label="Email *" model=".email">
              <Control.text model=".email" />
            </FormGroup>
          </Col>
          {renderServerError("email")}
          <Col {...colStyle}>
            <FormGroup label="First Name *" model=".first_name">
              <Control.text model=".first_name" required disabled={readOnly} />
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup label="Last Name *" model=".last_name">
              <Control.text model=".last_name" disabled={readOnly} />
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup label="Company Name *" model=".company_name">
              {isSubscriber || isNew ?
                <Control.text model=".company_name" />
                :
                <Control.text model=".compname" placeholder={item?.company_name} disabled/>
              }
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup label="Contact Number" model=".contact_number">
              <Control.text model=".contact_number" />
            </FormGroup>
          </Col>
          {(isSubscriber || isNew) ?
          <>
          <Col {...colStyle}>
            <FormGroup label="Tax Number" model=".tax_number">
              <Control.text model=".tax_number" />
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup label="Group" model=".group" hidden>
              <Control.text model=".group" defaultValue="Superadmin" disabled/>
            </FormGroup>
          </Col>
          </> 
          :
          <Col {...colStyle}>
            <FormGroup label="Group" model=".group" hidden>
              <Control.text model=".group" defaultValue={item.group ? item.group : null} disabled/>
            </FormGroup>
          </Col>
          }
          {isSetPass || isNew ? (
          <>
          <Col {...colStyle}>
            <FormGroup label="Password *" model=".password" hidden={readOnly}>
              <Control.text
                type="password"
                model=".password"
                validators={{ required: (v) => mode !== "New" || v }}
                autoComplete="new-password" 
              />
              {renderServerError("password")}
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup
              label="Confirm Password *"
              model=".confirmPassword"
              hidden={readOnly}
            >
              <Control.text
                type="password"
                model=".confirmPassword"
                validators={{ required: (v) => mode !== "New" || v }}
                autoComplete="new-password" 
              />
            </FormGroup>
          </Col>
          </>) : null}
        {(isSubscriber || isNew) &&
          <>
          <Col {...colStyle}>
            <FormGroup label="Trial Ends Date" model=".trial_ends_date">
              <DatePicker model=".trial_ends_date" className="form-control" />
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup label="Billing Type" model=".billed" addControlClass={false}>
              <Control.text
                style={{ backgroundColor: '#F4F7FE' }}
                model=".billed"
                component={Select}
                options={options}
                simpleValue
                clearable={true}
                placeholder="Select Period"
              />
            </FormGroup>
          </Col>
          <Col {...colStyle}>
            <FormGroup label="Subscription plan" model=".temp_subscription_plan" addControlClass={!planOptions}>
              {planOptions &&
                <Control.text
                  style={{ backgroundColor: '#F4F7FE' }}
                  model=".temp_subscription_plan"
                  component={Select}
                  options={planOptions}
                  defaultValue={planOptions[0].value}
                  clearable={true}
                  simpleValue
                  placeholder={t(`Select Plan`)}
                />}
            </FormGroup>
          </Col>
          </>
          }
        </Row>

        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <FormGroup label="User Status">
            <FormGroup label="Suspended" check disabled={readOnly}>
              <Control.checkbox
                model=".suspended"
                parser={(v) => (isUndefined(v) ? false : v)}
              />
            </FormGroup>
            <FormGroup label="Active" check disabled={readOnly}>
              <Control.checkbox
                model=".is_active"
                parser={(v) => (isUndefined(v) ? true : v)}
              />
            </FormGroup>
            {renderServerError("is_active")}
          </FormGroup>
        </div>

        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
          <FormGroup label="User Type">
            <FormGroup label="Internal user" check disabled={readOnly}>
              <Control.checkbox
                model=".is_internal_user"
                parser={(v) => (isUndefined(v) ? false : v)}
              />
            </FormGroup>

            {renderServerError("is_internal_user")}
          </FormGroup>
        </div>

        <div className="tw-flex">
          <BackButton className="mr-2" onClick={onBack} />
          <SaveButton form={form} hidden={readOnly} />
          <div className="mx-auto"/>
          {!isNew && <Button color="link" onClick={() => setPassword(!isSetPass)}><Trans>{isSetPass ? "Hide Password" : "Change Password"}</Trans></Button>}
        </div>


      </LocalForm>}
      <div className="clearfix" />
      {isSubscriber && stats && stats.length ? (
        <div>
          <hr />
          <h4 className="mb-3">
            <Trans>Monthly Organisation Statistics</Trans>
          </h4>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>
                  <Trans>Month</Trans>
                </th>
                <th>
                  <Trans>Organisation</Trans>
                </th>
                <th>
                  <Trans>Invoice</Trans>
                </th>
                <th>
                  <Trans>Employee</Trans>
                </th>
                <th>
                  <Trans>Loan</Trans>
                </th>
                <th>
                  <Trans>Time Off</Trans>
                </th>
                <th>
                  <Trans>Integration</Trans>
                </th>
                <th>
                  <Trans>Pay Run</Trans>
                </th>
              </tr>
            </thead>
            <tbody>
              {stats.map((i) => (
                <tr key={i.id}>
                  <td>{moment(i.month_of).format("MMMM YYYY")}</td>
                  <td>{i.organisation_name}</td>
                  <td>{i.sales_invoice || 0}</td>
                  <td>{i.employee || 0}</td>
                  <td>{i.loan_approval || 0}</td>
                  <td>{i.time_off || 0}</td>
                  <td>{i.integration || 0}</td>
                  <td>{i.pay_run || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
      </div>}
    </Page>
  );
};

const enhance = compose(
  withReload(),
  withServerErrors(),
  withStateHandlers(
    {},
    {
      setGlobalSettings: () => (globalSettings) => ({ globalSettings }),
      setStats: () => (stats) => ({ stats }),
    }
  ),
  withResolver(
    {
      globalSettings: () => (client) => client.get("global_settings"),
      stats:
        ({ match }) =>
        (client) =>
          client
            .get(`users/${match.params.id}/monthly_stats`)
            .get("data")
            .catch((err) => {
              return [];
            })
            .then((i) => ({
              data: orderBy(
                i,
                ["month_of", "organisation_name"],
                ["desc", "asc"]
              ),
            })),
    },
    {
      onResolved:
        ({ setGlobalSettings, setStats }) =>
        ({ globalSettings, stats }) =>
          void (setGlobalSettings(globalSettings), setStats(stats)),
    }
  ),
  EditPageContainer({
    url: "users",
    defaultItem: () => ({
      email: "",
      billed: "ANNUAL",
      accounting: true,
      payroll: false,
      wp_connect: false,
    }),
  }),

  withState("serverErrors", "setServerErrors", {})
);

export default enhance(UserEdit);
